// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empsettingspage-inline-1 {
  max-width: 480px;
}

.empsettingspage-dyn-1 {
  background: var(--empsettingspage-1-background);
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  color: var(--empsettingspage-1-color);
  font-weight: 600;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.empsettingspage-dyn-2 {
  background: var(--empsettingspage-2-background);
  border: 1px solid #fecaca;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  color: var(--empsettingspage-2-color);
  font-weight: 600;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpSettingsPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":[".empsettingspage-inline-1 {\n  max-width: 480px;\n}\n\n.empsettingspage-dyn-1 {\n  background: var(--empsettingspage-1-background);\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-size: 13px;\n  color: var(--empsettingspage-1-color);\n  font-weight: 600;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.empsettingspage-dyn-2 {\n  background: var(--empsettingspage-2-background);\n  border: 1px solid #fecaca;\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-size: 13px;\n  color: var(--empsettingspage-2-color);\n  font-weight: 600;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
